// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.
import emergency from './team-member-emergency-contacts.js';
import teamMemberPayslips from './team-member-payslips.js';
import teamMemberAssets from './team-member-assets.js';
import teamMemberMemos from './team-member-memos.js';
import teamMemberAttendances from './team-member-attendances.js';
import teamMemberTimeSheets from './team-member-time-sheets.js';
import teamMemberSalaryPackages from './team-member-salary-packages.js';
import teamMemberPayrollAdjustments from './team-member-payroll-adjustments.js';
import teamMemberFiles from './team-member-files.js';
import employmentHistories from './team-member-employment-histories.js';
import teamMemberSettings from './team-member-settings.js';
import teamMemberPaymentDetails from './team-member-payment-details.js';

export default [
    {
        path: '/:organisation/hr/team-members/import',
        component: () =>
            import('@/pages/[organisation]/hr/team-members/import.vue'),
        name: 'human-resource.team-members.upload-team-member-csv',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.team-member.create-team-member',
        },
    },
    {
        path: '/:organisation/hr/team-member-time-sheets/import',
        component: () =>
            import('@/pages/[organisation]/hr/team-member-time-sheets/import.vue'),
        name: 'human-resource.team-member-time-sheets.upload-time-sheet-csv',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.timesheet.import-team-member-time-sheet-csv',
        },
    },
    {
        path: '/:organisation/hr/team-members/archive',
        component: () =>
            import('@/pages/[organisation]/hr/team-members/archive.vue'),
        name: 'human-resource.team-members.archived-team-members',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.team-member.update-team-member',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/hr/team-members/archive/[id].vue'),
                name: 'human-resource.team-members.view-archived-team-member',
                meta: {
                    loginRequired: true,
                    permission: 'access.human-resource.team-member.update-team-member',
                },
            },
        ],
    },

    {
        path: '/:organisation/hr/team-members',
        component: () =>
            import('@/pages/[organisation]/hr/team-members.vue'),
        name: 'human-resource.team-members.search-team-members',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.team-member.view-team-members',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/hr/team-members/new.vue'),
                name: 'human-resource.team-members.create-team-member',
                meta: {
                    loginRequired: true,
                    permission: 'access.human-resource.team-member.create-team-member',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "human-resource.team-members" */ '@/pages/[organisation]/hr/team-members/team-members/[id].vue'),
                name: 'human-resource.team-members.view-team-member',
                meta: {
                    loginRequired: true,
                    permission: 'access.human-resource.team-member.view-team-members',
                },

                children: [
                    ...emergency,
                    ...teamMemberPayslips,
                    ...teamMemberAssets,
                    ...teamMemberAttendances,
                    ...teamMemberMemos,
                    ...teamMemberSalaryPackages,
                    ...teamMemberTimeSheets,
                    ...teamMemberPayrollAdjustments,
                    ...teamMemberFiles,
                    ...employmentHistories,
                    ...teamMemberSettings,
                    ...teamMemberPaymentDetails,
                ],
            },
            {
                path: ':id/edit',
                component: () =>
                    import(/* webpackChunkName: "human-resource.team-members" */ '@/pages/[organisation]/hr/team-members/team-members/[id]/edit.vue'),
                name: 'human-resource.team-members.update-team-member',
                meta: {
                    loginRequired: true,
                    permission: 'access.human-resource.team-member.update-team-member',
                },
            },
        ],
    },
];
